import React from 'react';
import { Form, Input, Button,Select,message,Spin,Result } from 'antd';
import { Table,Collapse,Popover,Popconfirm,Descriptions,Modal,Card } from 'antd';
import axios from 'axios'
import PhoneInput from 'react-phone-number-input'
import 'react-phone-number-input/style.css'
import * as serverconfig from '../serverconn'
import moment from 'moment';
import { SearchOutlined,LoadingOutlined,DeleteOutlined,FundViewOutlined,WalletFilled,EditOutlined } from '@ant-design/icons';

var CryptoJS = require("crypto-js");


const dateFormattn = 'HHmmssDDMMYYYY';
const dateFormat = 'DD/MM/YYYY';

const FormItem=Form.Item;
const { Option } = Select;
const { TextArea } = Input;
const antIcon = <LoadingOutlined style={{ fontSize: 60 }} spin />;

var token= ''
var username=''
var sacco=''


class MobileMoneycollectionform extends React.Component {

  state = {
    reason:'saving',  
    licence:'',
    remark:'sl_saving',
    companylogo:null,   
    companyphone:'',
    amount:0,
    accountslimit:0,
    branchname:'',
    website:'',
    address:'',
    datarequested:true,  
    safebalance:0,
    sharevalue:0,
    retainedearnings:0,
    packages:[],
    package:'',
    members:[],
    selectedaccount:'',
    companyprofile:{},
    message:'',
    selectedmemberobject:{}

  }


  componentDidMount(){
    if(localStorage.getItem("token")){
      token= localStorage.getItem("token")
   }else{
      token= ''
   }

   if(localStorage.getItem("sacco")){
    sacco= CryptoJS.AES.decrypt(localStorage.getItem("sacco") , 'my-secret-key@12345').toString(CryptoJS.enc.Utf8)
    username= CryptoJS.AES.decrypt(localStorage.getItem("username") , 'my-secret-key@123').toString(CryptoJS.enc.Utf8)
 
 }else{
    sacco= ''
    username=''
 }

    axios.defaults.headers={
      "Content-Type":"application/json",
      Authorization:`Token ${token}`
    }

    axios.get(serverconfig.backendserverurl+`/api/members/?sacco=${sacco}`)
    .then(res => {
        this.setState({
          members:res.data
        })

       // this.setState({datarequested:false})

    })


    axios.get(`${serverconfig.backendserverurl}/api/saccos/${sacco}`)
    .then(res => {  
        this.setState({
          companyprofile: res.data
        })

        this.setState({datarequested:false})

    })

    //set member now
    //this.setState({selectedaccount:Number(this.props.member_id)})

    //memeber change
    this.handlememberChange(Number(this.props.member_id))

}


handlememberChange= (e) =>{
  this.setState({ selectedmemberid: e});

  axios.get(`${serverconfig.backendserverurl}/api/members_dataview/${e}`)
  .then(res => {
       this.setState({selectedaccount:res.data.FullName})
      this.setState({selectedmemberobject: res.data})
  })

 } 




  ////////////////////////////////////
  // PRODUCT SEARCH SELECT METHODS
  onBlur=()=> {
    console.log('blur');
  }
  
   onFocus=()=>{
    console.log('focus');
  }
  
  onSearch=(val)=> {
    console.log('search:', val);
  }



  //submit button pressed
  handleFormSubmit=(event) =>{
    axios.defaults.headers={
      "Content-Type":"application/json",
      Authorization:`Token ${token}`
    }

    if(this.state.amount===0){
      alert("amount cant be zero")
    }else if(this.state.companyphone===''){
      alert("Phone number cant be empty")
    }else if (this.state.companyprofile.mobilemoneygatewaycode==="null" || this.state.companyprofile.mobilemoneygatewaycode===""){
    message.error("SMS gateway missing ")
    }else{

    this.setState({datarequested:true})

    let form_data = new FormData();
    form_data.append('reason', this.state.reason);
    form_data.append('remark', this.state.remark);
    form_data.append('phone', this.state.companyphone);
    form_data.append('amount', this.state.amount);
    form_data.append('requestfrom', "financialbranch");
    form_data.append('transactionId', "TXN"+moment().format(dateFormattn).toString());
    form_data.append('date', moment().format(dateFormat).toString());
    form_data.append('depositaccountnumber', this.state.selectedaccount);
    form_data.append('mmgatewaycode', this.state.companyprofile.mobilemoneygatewaycode);

    axios.post('https://mpg-a-p-i-2-pifs01-mta-app1.pitech.co.ug/customqueries/makemobilecollection', form_data, {
      headers: {
        'content-type': 'multipart/form-data'
      }
    })
  .then(res =>{
    this.setState({datarequested:false})
    this.setState({reason:''})
    this.setState({remark:''})
    this.setState({companyphone:''})
    this.setState({amount:0})

    this.setState({message:res.data.TransactionStatus})
    this.setState({datasubmittedsuccessfully:true})


   } 
  )
  .catch(error => console.log(error))

  }
 }

  handlereasonChange= (e) => this.setState({ reason: e.target.value});
  handleremarkChange= (e) => this.setState({ remark: e.target.value});
  handleCompanyamountChange= (e) => this.setState({ amount: e.target.value});

  render(){
    if(this.state.datarequested===true){
      return(
        <div style={{display: 'flex',  justifyContent:'center', alignItems:'center' }}>
        <Spin indicator={antIcon} />
        </div>
      )
    }else{
      return (
        <div >

{
  this.state.datasubmittedsuccessfully===true?
  <Card>
  <Result
  status="success"
  title={this.state.message}
  extra={[
    <Button  type='primary' onClick={()=>{window.location.reload(false)}}>Finish</Button>,
  ]}
  />
  </Card>
  :
  <Form
  onFinish={(event) => this.handleFormSubmit(event)}
  >
 
     {/* <FormItem label="Account">
          <Select 
          placeholder="Account No | Name" 
          style={{  }} 
          value={this.state.selectedaccount}
          onChange={(val)=>{this.setState({selectedaccount:val})}} 
          showSearch
          optionFilterProp="children"
          onFocus={this.onFocus}
          onBlur={this.onBlur}
          onSearch={this.onSearch}
                                
          >

              {this.state.members.map(
                (member)=>{

                if(Number(this.props.member_id)===Number(member.id)){
                  return (
                    <Option value={member.AccountNumber}>{member.AccountNumber} | {member.FullName}</Option>
                  );
                }

                })}


          </Select>
      </FormItem> */}

      <h3>{this.state.selectedmemberobject.FullName} | {this.state.selectedmemberobject.AccountNumber} </h3>



    <FormItem label="Phone Number">
    <PhoneInput
          countrySelectProps={{ unicodeFlags: true }}
          defaultCountry="UG"
          placeholder="Enter phone number"
          value={this.state.companyphone} onChange={(e) => this.setState({ companyphone: e})}/>
     </FormItem>

     
    <FormItem label="Amount">
      <Input name="amount" type='number'  placeholder="Amount here" value={this.state.amount} onChange={this.handleCompanyamountChange} />
    </FormItem>


      <FormItem>
        <Button type="primary" htmlType="submit" >Send request </Button>
      </FormItem>
    </Form>

  }

        </div>
      );
    }

  }

}


export default MobileMoneycollectionform;



